.base-graphic {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 140%;
    margin-left: -20%;
}

.base-graphic svg {
    width: 100%;
    height: 586px;
}

.modal-body ul {
    list-style-type: disc;
    padding-left: 20px;
}
